document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;
  const sections = document.querySelectorAll('.review_sec_main');
  if (!sections.length) return;
  sections.forEach(function (section) {
    const reviewSlider = section.querySelectorAll('.review_sec_content_slider');
    reviewSlider.forEach(function (revSlider) {
      const swiperEl = revSlider.querySelector('.swiper_review');
      if (!swiperEl) return;
      if (swiperEl.classList.contains('swiper-initialized')) return;
      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 40,
        navigation: {
          prevEl: revSlider.querySelector('.review_swiper_button_prev'),
          nextEl: revSlider.querySelector('.review_swiper_button_next')
        },
        breakpoints: {
          0: {
            slidesPerView: 1.4,
          },
          768: {
            slidesPerView: 1.6,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 2.6,
          }
        }
      });
    });
  });
});